import React from "react";
import { LuBrain as Brain } from "react-icons/lu";

import { DuoThoughtPost } from "../../types/post.type";

// Duo Thought Component
type DuoThoughtProps = {
  partner: DuoThoughtPost["partner"];
};

export const DuoThought = ({ partner }: DuoThoughtProps) => {
  return (
    <div className="bg-gradient-to-r from-amber-50/80 to-orange-50/80 p-4 rounded-xl border border-amber-100">
      <div className="flex items-center gap-2 mb-3">
        <Brain className="h-5 w-5 text-amber-600" />
        <h4 className="font-semibold text-amber-900">Duo Thought</h4>
      </div>
      <div className="bg-white/70 rounded-lg p-3 border border-amber-100">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center text-white text-xs font-semibold">
            {partner.userId.charAt(0).toUpperCase()}
          </div>
          <div>
            <div className="text-xs text-amber-600 font-medium">Collaboration Partner</div>
            <div className="font-semibold text-amber-900">{partner.userId}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
